import React from "react";
import { FIT_CARDS } from "../../data/mock";

const THEMES = {
  navy: { card: "bg-navy", num: "text-cream/40", title: "text-cream", body: "text-cream/65", icon: "bg-lime text-navy" },
  lime: { card: "bg-lime", num: "text-navy/40", title: "text-navy", body: "text-navy/65", icon: "bg-navy text-lime" },
  coral: { card: "bg-coral", num: "text-navy/40", title: "text-navy", body: "text-navy/70", icon: "bg-navy text-coral" },
  teal: { card: "bg-teal", num: "text-cream/50", title: "text-cream", body: "text-cream/80", icon: "bg-cream text-teal" },
};

export default function Fit() {
  return (
    <section id="industries" className="bg-cream grain px-5 md:px-8 py-20 lg:py-28">
      <div className="max-w-[1240px] mx-auto">
        <p className="font-mono text-[12px] uppercase tracking-[0.18em] text-teal">
          05 <span className="text-navy/40">—</span> The fit
        </p>
        <div className="mt-5 grid lg:grid-cols-2 gap-8 lg:gap-16 items-start">
          <h2 className="font-grotesk font-bold leading-[1.0] tracking-tight text-[clamp(2.25rem,5vw,4.25rem)]">
            <span className="text-navy">Made for</span>{" "}
            <span className="text-teal italic">high-intent calls.</span>
          </h2>
          <p className="lg:pt-4 text-navy/70 text-lg leading-relaxed max-w-md">
            When customers call because they need an answer—not just information—speed and reassurance can decide who earns the work.
          </p>
        </div>

        <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-4 gap-5">
          {FIT_CARDS.map((c) => {
            const t = THEMES[c.theme];
            const Icon = c.icon;
            return (
              <div
                key={c.n}
                className={`${t.card} rounded-3xl p-7 flex flex-col min-h-[280px] hover:-translate-y-1.5 transition-transform duration-300`}
              >
                <div className="flex items-center justify-between">
                  <span className={`font-mono text-[13px] ${t.num}`}>{c.n}</span>
                  <span className={`w-10 h-10 rounded-full flex items-center justify-center ${t.icon}`}>
                    <Icon className="w-5 h-5" />
                  </span>
                </div>
                <h3 className={`mt-8 font-grotesk text-2xl font-semibold ${t.title}`}>{c.title}</h3>
                <p className={`mt-3 leading-relaxed text-[14px] ${t.body}`}>{c.body}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
